//import {DATA_COMPONENT} from '../lib/types'

export const routeComponent = type => dispatch => {
    dispatch({type: type})
}